import { supabase } from "./supabaseClient";

export async function logEvent({
  entityType,
  entityId,
  action,
  summary,
  details = null,
  actor,
}) {
  if (!entityType || !entityId || !action || !summary) {
    console.error("logEvent called with missing required fields", {
      entityType,
      entityId,
      action,
      summary,
    });
    return;
  }

  const payload = {
    entity_type: entityType,
    entity_id: entityId,
    action,
    summary,
    details,
    actor_id: actor?.id || null,
    actor_name: actor?.email || null,
  };

  const { error } = await supabase.from("events").insert([payload]);
  if (error) {
    console.error("Error logging event:", error);
  }
}

